import * as VideoPlayerType from 'common/constants/video-player-type';
import * as VideoType from 'common/constants/video-type';
import ASVPComponent from './asvp';
import CVPComponent from './cvp';
import ExpiredSlate from 'common/components/expired-slate';
import styles from './styles.less';
import { observer, propTypes } from 'mobx-react';


@observer
class VideoPlayer extends React.Component {
    static propTypes = {
        asvp: React.PropTypes.bool,
        cvp: React.PropTypes.bool,
        onExpiredSlateCountdown: React.PropTypes.func,
        playerProps: React.PropTypes.object.isRequired,
        video: propTypes.objectOrObservableObject
    };

    static defaultProps = {
        asvp: false,
        cvp: false,
        playerProps: {}
    };
    render() {
        const playerType = this.getPlayerType();
        return (
            <div
                className={ cx(styles.root, this.props.className) }
                style={ this.props.style }>
                { !!(this.props.video && this.props.video.expired && this.props.onExpiredSlateCountdown) &&
                <ExpiredSlate
                    className={ styles.expiredSlate }
                    onCountdown={ this.props.onExpiredSlateCountdown }
                    video={ this.props.video }
                /> }
                <ASVPComponent
                    { ...this.props.playerProps }
                    ref='playerComponent'
                    style={{ display: (playerType !== VideoPlayerType.ASVP) ? 'none' : null }}
                    video={ (playerType === VideoPlayerType.ASVP) ? this.props.video : null }
                />
                { (playerType === VideoPlayerType.CVP) &&
                <CVPComponent
                    { ...this.props.playerProps }
                    ref='playerComponent'
                    video={ this.props.video }
                /> }
            </div>
        );
    }

    getPlayer() {
        return this.refs.playerComponent;
    }

    getPlayerType() {
        const { video } = this.props;
        if (!video) {
            return null;
        }
        if ((this.props.cvp && !this.props.asvp) || video.auth === true || (!this.props.asvp && video.type === VideoType.EPISODE)) {
            return VideoPlayerType.CVP;
        }
        return VideoPlayerType.ASVP;
    }
}


export default VideoPlayer;



/** WEBPACK FOOTER **
 ** ./src/common/components/video-player/index.js
 **/